module.exports = __webpack_public_path__ + "static/media/icon-fone.c7f5a34c.svg";